<template>
  <transition>
    <div class="ui-menu overlay" v-if="show" @click="onClickOverlay" ref="overlay">
      <div class="menu-content">
        <div class="header">
          <div>
            <img src="../assets/default-avatar.png" alt="avatar" />
          </div>
          <div class="personal-info">
            <span class="name">{{ currentUser.username }}</span>
            <span class="role">({{ getRoleUser() }})</span>
            <div class="curren_store" @click="showStore = !showStore">
              {{ getCurrenStore() }} <UiBaseIcon iconName="arrowDown" height="18" width="18" />
            </div>
          </div>
        </div>
        <div class="nav">
          <ul v-show="showStore">
            <li v-for="store in listStore" :key="store.id" @click="changeStore(store.id, store.type, store.store_external_id)">
              <a>{{ store.url }}</a>
            </li>
          </ul>
          <ul>
            <li v-for="(item, index) in sider" :key="index" @click="close">
              <router-link :to="{ name: item.link }"> <UiBaseIcon :iconName="item.icon" height="18" width="18" />{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
        <div class="nav__logout">
          <button class="btn" type="button" @click="$emit('logout')">Sign out</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import sildebarData from '@/constants/slidebar'
import UiBaseIcon from '@/components/icons/UiBaseIcon'
export default {
  name: 'UiMenuMobile',
  components: {
    UiBaseIcon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object,
      default: () => {}
    },
    currenStore: {
      type: String,
      default: null
    },
    listStore: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      sider: sildebarData,
      showStore: false
    }
  },
  methods: {
    close () {
      this.showStore = false
      this.$emit('update:show', false)
    },
    onClickOverlay ($event) {
      if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
        this.close()
      }
    },
    getCurrenStore () {
      const id = this.currenStore || null
      const store = this.listStore.find(store => store.id === id)
      if (store) {
        return store.url
      }
      return 'No store'
    },
    changeStore (storeId, type, storeExternalId) {
      this.$emit('changeStore', storeId, type, storeExternalId)
      this.close()
    },
    getRoleUser () {
      let roles = ''
      this.currentUser.roles.forEach((roleName, index) => {
        if (index === 0) {
          roles = roleName
        } else {
          roles = `${roles},${roleName}`
        }
      })
      return roles
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-menu.overlay {
  width: 100vw;
  height: 100vh;
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  transition: all 0.15s ease-in-out;
  .menu-content {
    width: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #ffffff;
    .header {
      display: flex;
      align-items: center;
      background-color: $color-black-100;
      padding: 15px;
      .personal-info {
        margin-left: 10px;
        .name {
          color: var(--primary-color);
          margin-right: 5px;
        }
        .role {
          color: #ffffff;
        }
      }
      .curren_store {
        color: #ffffff;
        font-size: 14px;
      }
    }
    .nav__logout {
      position: absolute;
      bottom: 30px;
      display: flex;
      justify-content: center;
      width: 100%;
      button {
        background: #3a465c;
        color: var(--primary-color);
        width: 160px;
        font-weight: 600;
      }
    }
    .nav {
      li {
        border-top: 1px solid $color-black-200;
        padding: 5px;
      }
      .is-active {
        color: var(--primary-color);
      }
      a {
        white-space: nowrap;
        color: $color-gray-450;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        padding: 14px 22px;
        text-decoration: none;
        white-space: nowrap;
        font-size: 12px;
        span {
          margin-right: 10px;
        }
      }
    }
    .nav .nav a:hover {
      color: var(--primary-color);
    }
    .nav a:hover svg {
      fill: var(--primary-color);
    }
  }
}

/* menu transition */
.menu-enter-active,
.menu-leave-active {
  transition: all 0.3s ease;
}
.menu-enter,
.menu-leave-to {
  padding-top: 100px;
  opacity: 0;
}
</style>
